import React from "react";
import {
    Button,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import CountrySelect from "react-bootstrap-country-select";
import {
    Map,
    Marker,
    GoogleApiWrapper,
} from "google-maps-react";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNewDistributer } from "../../store/actions/DistributerActions";
Geocode.setApiKey("AIzaSyDJ05MSObzmYtm4ql0L0bbzibVFmi6BruE");
function DistributerForm(props) {
    const dispatch = useDispatch();
    const { add_loading } = useSelector((state) => state.distributer);
    const [formData, setFormData] = useState({
        name: "",
        company: "",
        category: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
        email: "",
        phone: "",
        businessTime: "",
        offerBrands: "",
        interestedproductList: "",
        currentSeller: "",
        comments: "",
        website: false,
        walkInStore: false,
        mobileTrucks: false,
        others: false,
        sell: false,
        internalUser: false,
        both: false,
        whereToBuyBrand: false,
        privateLabel: false,
        CurrentlyCarry: false,
        haveWebsite: false,
        payment: false,
    });

    const [targetMarket, setTargetMarket] = useState([]);

    const handleTargetMarketChange = (e) => {
        if (e.target.checked) {
            setTargetMarket([...targetMarket, e.target.name]);
        } else {
            setTargetMarket(
                targetMarket.filter((item) => item !== e.target.name)
            );
        }
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const [value, setValue] = useState(null);
    const [address, setAddress] = useState("");
    const [mapCenter, setMapCenter] = useState({
        lat: 33.6322421,
        lng: 73.07202,
    });

    const getLatLngAddress = (lat, lng) => {
        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                let address;
                address = response.results[0].formatted_address;
                setAddress(address);
            },
            (error) => {
                console.error(error);
            }
        );
    };
    const handlemapChange = (newAddress) => {
        setAddress(newAddress);
    };

    const handleSelect = (newAddress) => {
        setAddress(newAddress);
        geocodeByAddress(newAddress)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => {
                // console.log("Success", latLng);

                // update center state
                setMapCenter(latLng);
            })
            .catch((error) => console.error("Error", error));
    };
    const handleMarkerDrag = (e) => {
        const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        setMapCenter(latLng);
        getLatLngAddress(latLng.lat, latLng.lng);
    };
    const clearForm = () => {
        setFormData({
            name: "",
            company: "",
            category: "",
            address: "",
            city: "",
            state: "",
            zipcode: "",
            email: "",
            phone: "",
            businessTime: "",
            offerBrands: "",
            interestedproductList: "",
            currentSeller: "",
            comments: "",
            website: false,
            walkInStore: false,
            mobileTrucks: false,
            others: false,
            sell: false,
            internalUser: false,
            both: false,
            whereToBuyBrand: false,
            privateLabel: false,
            CurrentlyCarry: false,
            haveWebsite: false,
            payment: false,
        });
        setTargetMarket([]);
        setValue(null);
        setAddress("");
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(formData);
        // console.log(targetMarket);
        // console.log(mapCenter);
        if (
            formData.name &&
            formData.company &&
            formData.category &&
            formData.address &&
            formData.email &&
            formData.phone
        ) {
            dispatch(
                addNewDistributer(
                    formData,
                    targetMarket,
                    mapCenter,
                    value,
                    () => {
                        clearForm();
                    }
                )
            );
        } else {
            alert("Please fill all the required fields first.");
        }
    };
    return (
        <Container fluid>
            <Form className="distributerForm" onSubmit={handleSubmit}>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label>
                            Company<span className="text-danger">*</span>
                        </Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="company"
                                type="text"
                                value={formData.company}
                                onChange={handleChange}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>
                            Name <span className="text-danger">*</span>
                        </Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>
                            Email<span className="text-danger">*</span>
                        </Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                type="text"
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>
                            Phone<span className="text-danger">*</span>
                        </Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                type="text"
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>
                            Category<span className="text-danger">*</span>
                        </Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                className="distributerForm__select"
                                name="category"
                                type="select"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="" selected disabled>
                                    Select Category
                                </option>
                                <option value="brick_&_mortar_stores">
                                    Brick & Mortar Stores
                                </option>
                                <option value="delivery_services">
                                    Delivery Service
                                </option>
                                <option value="online_stores">
                                    {" "}
                                    Online Stores
                                </option>
                                <option value="ida_members">IDA Members</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                        <Label>
                            Address<span className="text-danger">*</span>
                        </Label>
                        <br />
                        <Label>Street Address</Label>

                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                type="text"
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>City</Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="city"
                                type="text"
                                value={formData.city}
                                onChange={handleChange}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>State/Region/Province</Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="state"
                                type="text"
                                value={formData.state}
                                onChange={handleChange}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>Zip/Postal Code</Label>
                        <FormGroup>
                            <Input
                                id="exampleSelect"
                                name="zipcode"
                                value={formData.zipcode}
                                onChange={handleChange}
                                type="text"
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label>Country</Label>
                        <CountrySelect
                            value={value}
                            onChange={setValue}
                            flags={false}
                        />
                    </Col>

                    {/* <Col md={6} sm={12} xs={12}>
                        <Label>
                            Are you interested in Where to Buy Manufacturing
                            branded product or private label?
                        </Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-flex justify-content-between">
                                    <Col className="text-nowrap">
                                        <Input
                                            type="radio"
                                            name="whereToBuyBrand"
                                            checked={formData.whereToBuyBrand}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    whereToBuyBrand: true,
                                                    privateLabel: false,
                                                }))
                                            }
                                        />
                                        Where to Buy Brand
                                    </Col>
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="privateLabel"
                                            checked={formData.privateLabel}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    whereToBuyBrand: false,
                                                    privateLabel: true,
                                                }))
                                            }
                                        />
                                        Private Label
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>

                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label>Are you a reseller or end user?</Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-flex justify-content-between">
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="sell"
                                            checked={formData.sell}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    sell: true,
                                                    internalUser: false,
                                                    both: false,
                                                }))
                                            }
                                        />
                                        Sell
                                    </Col>
                                    <Col className="text-nowrap">
                                        <Input
                                            type="radio"
                                            name="internalUser"
                                            checked={formData.internalUser}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    sell: false,
                                                    internalUser: true,
                                                    both: false,
                                                }))
                                            }
                                        />
                                        Internel User
                                    </Col>
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="both"
                                            checked={formData.both}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    sell: false,
                                                    internalUser: false,
                                                    both: true,
                                                }))
                                            }
                                        />
                                        Both
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label>
                            Do you currently carry any Where to Buy products?
                        </Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-flex justify-content-between">
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="CurrentlyCarry"
                                            onChecked={formData.CurrentlyCarry}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    CurrentlyCarry: true,
                                                }))
                                            }
                                            id="exampleText"
                                        />
                                        Yes
                                    </Col>
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="CurrentlyCarry"
                                            onChecked={formData.CurrentlyCarry}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    CurrentlyCarry: false,
                                                }))
                                            }
                                        />
                                        No
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label for="exampleText">
                                If already established, how long have you been
                                in business?
                            </Label>
                            <Input
                                type="text"
                                name="businessTime"
                                value={formData.businessTime}
                                onChange={handleChange}
                                id="exampleText"
                            />
                        </FormGroup>
                    </Col> */}
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label>Do you have a website?</Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-flex justify-content-between">
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="haveWebsite"
                                            onChecked={formData.haveWebsite}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    haveWebsite: true,
                                                }))
                                            }
                                        />
                                        Yes
                                    </Col>
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="haveWebsite"
                                            onChecked={formData.haveWebsite}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    haveWebsite: false,
                                                }))
                                            }
                                        />
                                        No
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label>
                            How do you sell or intend to sell our product?
                        </Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-lg-flex d-sm-block justify-content-between">
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="website"
                                            checked={formData.website}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    workInStore: false,
                                                    mobileTrucks: false,
                                                    website: true,
                                                    others: false,
                                                }))
                                            }
                                        />
                                        Website
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="workInStore"
                                            checked={formData.workInStore}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    workInStore: true,
                                                    mobileTrucks: false,
                                                    website: false,
                                                    others: false,
                                                }))
                                            }
                                        />
                                        Walk in Store
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="mobileTrucks"
                                            checked={formData.mobileTrucks}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    mobileTrucks: true,
                                                    website: false,
                                                    workInStore: false,
                                                    others: false,
                                                }))
                                            }
                                        />
                                        Mobile Trucks
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="others"
                                            checked={formData.others}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    mobileTrucks: false,
                                                    website: false,
                                                    workInStore: false,
                                                    others: true,
                                                }))
                                            }
                                        />
                                        Others
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label>Who is your target market?</Label>
                        <p>Please check all that apply</p>

                        <Row>
                            <Col md={12}>
                                <FormGroup className="justify-content-between d-lg-flex d-sm-block ">
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="DIYConsumer"
                                            id="exampleText"
                                            checked={targetMarket.DIYConsumer}
                                            onChange={handleTargetMarketChange}
                                        />
                                        DIY Consumer
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="ProfessionalDetailer"
                                            id="exampleText"
                                            checked={
                                                targetMarket.ProfessionalDetailer
                                            }
                                            onChange={handleTargetMarketChange}
                                        />
                                        Professional Detailer
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="Dealership"
                                            id="exampleText"
                                            checked={targetMarket.Dealership}
                                            onChange={handleTargetMarketChange}
                                        />
                                        Dealership
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="BodyShops"
                                            id="exampleText"
                                            checked={targetMarket.BodyShops}
                                            onChange={handleTargetMarketChange}
                                        />
                                        BodyShops
                                    </Col>
                                    <Col>
                                        <Input
                                            type="checkbox"
                                            name="Other"
                                            id="exampleText"
                                            checked={targetMarket.Other}
                                            onChange={handleTargetMarketChange}
                                        />
                                        Other
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label for="exampleText">
                                What brand(s) of buffing and polishing products
                                are you offering currently?
                            </Label>
                            <Input
                                type="textarea"
                                name="offerBrands"
                                value={formData.offerBrands}
                                onChange={handleChange}
                                id="exampleText"
                            />
                        </FormGroup>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label for="exampleText">
                                Do you need assistance in establishing a product
                                mix or do you have Where to Buy products
                                specifically that you are already interested in?
                                If you have some in mind, please list below.
                            </Label>
                            <Input
                                type="textarea"
                                name="interestedproductList"
                                value={formData.interestedproductList}
                                onChange={handleChange}
                                id="exampleText"
                            />
                        </FormGroup>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label for="exampleText">
                                Do you currently sell Rotary or DA polishers,
                                and if so what brands do you offer?
                            </Label>
                            <Input
                                type="textarea"
                                name="currentSeller"
                                id="exampleText"
                                value={formData.currentSeller}
                                onChange={handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <Label for="exampleText">
                            To become a distributor, are you able to meet an
                            opening order minimum of $1,500 (domestic) or $2,500
                            (international)?
                        </Label>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="d-flex justify-content-between">
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="payment"
                                            onChecked={formData.payment}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    payment: false,
                                                }))
                                            }
                                        />
                                        Yes
                                    </Col>
                                    <Col>
                                        <Input
                                            type="radio"
                                            name="payment"
                                            onChecked={formData.payment}
                                            onChange={(e) =>
                                                setFormData((currentState) => ({
                                                    ...currentState,
                                                    payment: false,
                                                }))
                                            }
                                        />
                                        No
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="my-3" md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label for="exampleText">Additional Comments</Label>
                            <Input
                                type="textarea"
                                name="comments"
                                onChange={handleChange}
                                value={formData.comments}
                                id="exampleText"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="my-5">
                        <PlacesAutocomplete
                            value={address}
                            onChange={handlemapChange}
                            onSelect={handleSelect}
                        >
                            {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                            }) => (
                                <div>
                                    <input
                                        {...getInputProps({
                                            placeholder:
                                                "Business Position ...",
                                            className: "location-search-input",
                                        })}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion) => {
                                            const className = suggestion.active
                                                ? "suggestion-item--active"
                                                : "suggestion-item";
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? {
                                                      backgroundColor:
                                                          "#fafafa",
                                                      cursor: "pointer",
                                                  }
                                                : {
                                                      backgroundColor:
                                                          "#ffffff",
                                                      cursor: "pointer",
                                                  };
                                            return (
                                                <div
                                                    className="input-suggestion"
                                                    {...getSuggestionItemProps(
                                                        suggestion,
                                                        {
                                                            style,
                                                        }
                                                    )}
                                                >
                                                    <span>
                                                        {suggestion.description}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>

                        <Map
                            className="map"
                            google={props.google}
                            initialCenter={mapCenter}
                            center={mapCenter}
                        >
                            <Marker
                                key={"marker"}
                                position={mapCenter}
                                draggable={true}
                                onDragend={(t, map, coord) => {
                                    handleMarkerDrag(coord);
                                }}
                            />
                        </Map>
                    </Col>
                </Row>
                <div className="text-center">
                    <Button
                        color="white"
                        className="text-dark form-btn btn border border-4 mr-5"
                        size="lg"
                        disabled={add_loading}
                    >
                        {add_loading ? <Spinner size="sm" /> : "Submit"}
                    </Button>
                </div>
            </Form>
        </Container>
    );
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyDJ05MSObzmYtm4ql0L0bbzibVFmi6BruE",
})(DistributerForm);
